const LoadingSpinner = () => (
  <div className="flex justify-center items-center h-64">
    <div className="animate-spin inline-block w-8 h-8 border-4 border-gray-300 border-t-teal-600 rounded-full"></div>
  </div>
);

export default LoadingSpinner;
